import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { createApprovalRule, getRoles, updateApprovalRule } from './createApprovalRule.helper';
import { CreateApprovalRulePayload } from './createApprovalRule.types';

export const useRoles = () =>
  useQuery({
    queryKey: ['ApprovalRoles'],
    queryFn: () => getRoles(),
    retry: 1,
    staleTime: 1000 * 60 * 5, // cache 5 min
  });

export const useCreateApprovalRule = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: CreateApprovalRulePayload) => createApprovalRule(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['ApprovalRules'] });
    },
  });
};

export const useUpdateApprovalRule = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: CreateApprovalRulePayload }) =>
      updateApprovalRule(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['ApprovalRules'] });
      queryClient.invalidateQueries({ queryKey: ['ApprovalRuleDetail'] });
    },
  });
};
